import { render, staticRenderFns } from "./produk.vue?vue&type=template&id=3e145960&"
import script from "./produk.vue?vue&type=script&lang=js&"
export * from "./produk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports